import { useTheme } from 'styled-components';

import { Modal } from '@/core/components/Modal/Modal';
import { OverlayStyle } from '@/core/components/Modal/Modal.types';
import { Button, ButtonVariant } from '@/core/components/Button';
import { Paragraph } from '@/core/components/Typography';
import { Icon } from '@/core/components/Icons';
import { useTopmostZIndex } from '@/core/hooks/useTopmostZIndex';

import {
  ButtonsContainer,
  CloseButton,
  ModalContainer,
  ModalHeader,
  TitleWrapper,
} from './CloseModal.styles';
import { CloseModalProps } from './CloseModal.types';

export const CloseModal = ({ isOpen, analysisTitle, onCancel, onConfirm }: CloseModalProps) => {
  const { colors } = useTheme();
  const zIndex = useTopmostZIndex(isOpen);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      overlayStyle={OverlayStyle.BLUR}
      zIndex={zIndex}
    >
      <ModalContainer>
        <ModalHeader>
          <Paragraph type="bold">{`Close analysis "${analysisTitle}" without saving?`}</Paragraph>
          <CloseButton
            type="button"
            onClick={onCancel}
            aria-label="Close modal"
          >
            <Icon
              name="Close"
              size={14}
            />
          </CloseButton>
        </ModalHeader>
        <TitleWrapper>
          <Paragraph
            type="normal"
            color={colors.secondaryText}
          >
            You have unsaved edits. If you close now, you won&#39;t be able to make further changes.
          </Paragraph>
        </TitleWrapper>
        <ButtonsContainer>
          <Button
            variant={ButtonVariant.WARNING}
            onClick={onConfirm}
          >
            YES, CLOSE
          </Button>
          <Button
            variant={ButtonVariant.SECONDARY}
            onClick={onCancel}
          >
            CANCEL
          </Button>
        </ButtonsContainer>
      </ModalContainer>
    </Modal>
  );
};
